var _defs, _rect, _rect2, _path, _rect3, _circle, _circle2, _rect4, _rect5, _rect6, _circle3, _rect7, _rect8, _rect9, _circle4, _rect10, _rect11, _rect12, _circle5, _rect13, _rect14, _rect15, _circle6, _rect16, _rect17, _rect18, _rect19, _rect20, _circle7, _circle8, _g, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b9a38b5d-9c66-4a75-a477-70b37749fa7e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 666.24,
    height: 728.82,
    viewBox: "0 0 666.24 728.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0b4bbb50-2c74-4271-bf06-9944ea4886f0",
    x1: 600,
    y1: 814.41,
    x2: 600,
    y2: 85.59,
    gradientTransform: "translate(-266.87 -85.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3343e46b-8287-40fd-bf41-51a7a19771a9",
    x1: 333.12,
    y1: 540.89,
    x2: 333.12,
    y2: 294.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#0b4bbb50-2c74-4271-bf06-9944ea4886f0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "53153d7b-989b-4b45-8d94-5525de3b761a",
    x1: 176.82,
    y1: 463.53,
    x2: 176.82,
    y2: 349.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#0b4bbb50-2c74-4271-bf06-9944ea4886f0"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "select") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.23,
    width: 403.77,
    height: 728.81,
    rx: 15.34,
    ry: 15.34,
    fill: "url(#0b4bbb50-2c74-4271-bf06-9944ea4886f0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.69,
    y: 9.85,
    width: 392.86,
    height: 709.12,
    rx: 13.64,
    ry: 13.64,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M698.7,113.22a31.85,31.85,0,0,1-31.39,27.09H531.61a31.85,31.85,0,0,1-31.39-27.09H428.35a14.92,14.92,0,0,0-14.92,14.92V771.86a14.92,14.92,0,0,0,14.92,14.92H771.65a14.92,14.92,0,0,0,14.92-14.92V128.14a14.92,14.92,0,0,0-14.92-14.92Z",
    transform: "translate(-266.88 -85.59)",
    fill: "#0f5980",
    opacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 289.9,
    y: 36.12,
    width: 87.55,
    height: 5.47,
    rx: 2,
    ry: 2,
    fill: "#dbdbdb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 396.05,
    cy: 38.31,
    r: 3.28,
    fill: "#dbdbdb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.47,
    cy: 164.78,
    r: 40.07,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 134.72,
    width: 71.38,
    height: 12.52,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 158.51,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 182.31,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.47,
    cy: 283.75,
    r: 40.07,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 253.69,
    width: 71.38,
    height: 12.52,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 277.49,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 301.28,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.47,
    cy: 402.72,
    r: 40.07,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 372.66,
    width: 71.38,
    height: 12.52,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 396.46,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 420.25,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.47,
    cy: 521.69,
    r: 40.07,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 491.63,
    width: 71.38,
    height: 12.52,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 515.43,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 539.22,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.47,
    cy: 640.66,
    r: 40.07,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 610.61,
    width: 71.38,
    height: 12.52,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 634.4,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 282.37,
    y: 658.19,
    width: 196.62,
    height: 12.52,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    y: 294.6,
    width: 666.24,
    height: 246.29,
    fill: "url(#3343e46b-8287-40fd-bf41-51a7a19771a9)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 4.74,
    y: 299.34,
    width: 656.77,
    height: 227.34,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.82,
    cy: 406.7,
    r: 56.84,
    fill: "url(#53153d7b-989b-4b45-8d94-5525de3b761a)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.82,
    cy: 406.7,
    r: 50.52,
    fill: "#0f5980"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.28,
    y: 368.8,
    width: 89.99,
    height: 15.79,
    fill: "#0f5980"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.28,
    y: 398.8,
    width: 247.87,
    height: 15.79,
    fill: "#0f5980"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.28,
    y: 428.8,
    width: 247.87,
    height: 15.79,
    fill: "#0f5980"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "209.98 386.44 198.88 377.97 169.64 416.29 153.32 403.83 144.85 414.93 166.73 431.63 166.79 431.55 172.32 435.77 209.98 386.44",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.a8583e6b26017a87200db5988fe8e6f0.svg";
export { ForwardRef as ReactComponent };